module.exports = __webpack_public_path__ + "img/borders1.5f4fabb0.png";